module.exports = __webpack_public_path__ + "media/images/emblems/Schwarzhaeusern-coat_of_arms-a6c1ca22910f8e768eadbdedb3e97045.svg";